// extracted by mini-css-extract-plugin
export default {"addToCartControl":"_1-z","giftCard":"a2-z","btnContainer":"b2-z","cartButton":"c2-z","disabled":"d2-z"};